<template>
    <div>
        <div class="logo">
            <span class="logo-title" >医生工作站</span>
            <ul class="header-content-list fr clearfix set-content-list">
                <!--<li class="header-content-item">-->
                    <!--<router-link class="header-content-link" to="/personalPage">-->
                        <!--&lt;!&ndash;<img src="../../images/icon-person.png" alt="头像" class="icon-person">&ndash;&gt;-->
                        <!--<img :src="userInfo.docAvatar?userInfo.docAvatar:require('../../../images/doc-default-icon.png')" class="header-personal-icon">-->
                        <!--{{ userInfo.docName }}-->
                    <!--</router-link>-->
                <!--</li>-->
                <!--<li class="header-content-item">-->
                    <!--<el-dropdown>-->
                              <!--<span class="el-dropdown-link" >-->
                             <!--<svg class="icon fontSize12" aria-hidden="true">-->
                                <!--<use xlink:href="#icon-kefu"></use>-->
                            <!--</svg>-->
                              <!--</span>-->
                        <!--<el-dropdown-menu slot="dropdown" style="border-radius: 5px;overflow: hidden;padding:0;">-->
                            <!--<div class="header-yz" style="width:200px;height:160px;">-->
                                <!--<h1 style="text-align: left;">医助工作时间:</h1>-->
                                <!--<p style="font-size: 12px;line-height: 20px;color:#888888;">周一至周五</p>-->
                                <!--<p style="font-size: 12px;line-height: 20px;color:#888888;">（上午8:00-11:30）</p>-->
                                <!--<p style="font-size: 12px;line-height: 20px;color:#888888;">（下午13:30-17:00）</p>-->
                                <!--<div class="header-bottom">-->
                                    <!--<p style="font-size: 14px;">0571-87767077</p>-->
                                    <!--<p style="font-size: 14px;">661888（院内）</p>-->
                                <!--</div>-->
                            <!--</div>-->
                        <!--</el-dropdown-menu>-->
                    <!--</el-dropdown>-->
                <!--</li>-->
                <!--<li class="header-content-item">-->
                       <!--<span class="header-content-link" >-->
                          <!--<el-dropdown @command="linkTo" trigger="click" >-->
                             <!--<span class="hover-cursor gray-color" @click="dropDownHandler">-->
                                 <!--<el-badge :value="allMsgBoxListCounts" class="header-badge item" :max="99">-->
                                     <!--<svg class="icon fontSize16" aria-hidden="true">-->
                                        <!--<use xlink:href="#icon-xiaoxi"></use>-->
                                     <!--</svg>-->
                                     <!--&lt;!&ndash;<img src="../../images/icon-msg.png" alt="消息">&ndash;&gt;-->
                                 <!--</el-badge>-->
                                 <!--&lt;!&ndash;消息<i class="el-icon-caret-bottom el-icon&#45;&#45;right "></i>&ndash;&gt;-->
                             <!--</span>-->
                                <!--<el-dropdown-menu slot="dropdown" class="fontSize12" >-->
                                    <!--<el-dropdown-item :class="[item.isread?'clicked-item':'']" :command="JSON.stringify(item)" v-for="(item,index) in partMsgBoxList" :key="index">{{ '【'+ item.messageTitle + '】' + item.messageBody }}</el-dropdown-item>-->
                                    <!--<span v-show="partMsgBoxList.length!=0" class="hover-cursor fr marginR10" @click="showMsgListBox">更多>></span>-->
                                <!--</el-dropdown-menu>-->
                            <!--</el-dropdown>-->
                       <!--</span>-->
                    <!--<MsgListBoxCmp/>-->
                <!--</li>-->
                <li class="header-content-item">
                    <router-link class="header-content-link" to="/setUp">
                        <svg class="icon fontSize16" aria-hidden="true">
                            <use xlink:href="#icon-shezhi"></use>
                        </svg>
                        <!--<img class=" icon-person" src="../../images/icon-set.png" alt="设置">-->
                    </router-link>
                </li>
                <li class="header-content-item">
                        <span class="logout-btn header-content-link" @click="logout">
                            <svg class="icon fontSize18" aria-hidden="true">
                                <use xlink:href="#icon-tuichu"></use>
                            </svg>
                            <!--<img src="../../images/icon-power.png" alt="退出/登录">-->
                        </span>
                </li>
            </ul>
        </div>
        <div class="login-title h50 set-header-top">
            <router-link to="/main">&lt;返回首页</router-link>
        </div>
    </div>
</template>
<style>

</style>
<script>
    import { MessageBox } from 'element-ui';
    import { formatUnixTime } from "../../utils/DateFormat.js";
    import MsgListBoxCmp from "../common/MsgListBoxCmp.vue";
    import axiosUtil from "../../utils/AxiosUtils.js"
    import MsgBoxListUtils from "../../utils/MsgBoxListUtils.js"
    import { HOST_URL } from "../../data/Url.js";
    export default{
        data: function(){
            return {
                userInfo: JSON.parse(sessionStorage.getItem("loginInfo")),
                //userName: JSON.parse(sessionStorage.getItem("loginInfo")).docName,
                //docAvatar: JSON.parse(sessionStorage.getItem("loginInfo")).docAvatar,
            }
        },
        components:{
            MsgListBoxCmp
        },
        computed: {
            // allMsgBoxListCounts: function() { // 未读消息数
            //     return this.$store.state.allMsgBoxListCounts;
            // },
            // partMsgBoxList: function() {
            //     if(this.$store.state.allMsgBoxList.list){
            //         return this.$store.state.allMsgBoxList.list.slice(0, 10);
            //     }else {
        	 //        return [];
            //     }
            // },
            // allMsgBoxList: function() {
            //     return this.$store.state.allMsgBoxList.list;
            // }
        },
        created: function() {
            // this.$store.dispatch("getAllMsgBoxList");// 获取消息盒子列表内容总数
            // this.$store.dispatch("getAllMsgBoxListCounts");// 获取消息盒子未读数
        },
        methods: {
            logout: function(e){//退出登录
                e.stopPropagation();
                let _this = this;
                MessageBox.confirm('确认退出登录?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    let options = {
                        token: localStorage.getItem("token"),
                        Service: "smarthos.user.doc.exit"
                    };
                    axiosUtil(options, function(){
                        // window.location = HOST_URL;
                        _this.$router.push("/login");
                        localStorage.removeItem("docId");
                        localStorage.removeItem("userInfo");
                        localStorage.removeItem("token");
                        localStorage.removeItem("txtConfID");
                        _this.$store.dispatch("changeSideItem", "wlmz");
                    });
                    //this.$store.dispatch("changeSideItem", "rwzx");
                }).catch(() => {
                });
            },
            linkTo: function(itemJSON){//点击消息下拉菜单 跳转
                MsgBoxListUtils(this, itemJSON);
            },
            dropDownHandler: function(){// 获取消息盒子下拉列表数据
                this.$store.dispatch("getAllMsgBoxList", 1);
            },
            // linkToSetUp: function (ev) {//跳转到设置.更改侧边栏高亮
            //     let e = ev || event;
            //     if(e.preventDefault){
            //         e.preventDefault();
            //         e.stopPropagation();
            //     }else {
            //         e.cancelBubble = true;//停止冒泡
            //         e.returnValue = false;//阻止事件的默认行为
            //     }
            //     this.$router.push("/setUp");
            //     this.$store.dispatch("getSetUpClickName", "myInfo");
            // },
            showMsgListBox: function(ev) {// 现实消息盒子
                //this.dialogTableVisible = true;
                this.$store.dispatch("isOpenMsgListBox", true);// 打开消息盒子
            },
        }
    }
</script>
